
import { type IRespuestaApiLista } from '../../globales/interfaces';
import api from '../../utils/api';
import type { IFiltroUsuario } from './entidades/IFiltroUsuario';
import type { IUsuario } from './entidades/IUsuario';

// Modelo de Autenticación
class ModeloUsuario {
    constructor() { }

    public async obtenerListaUsuarios(filtro: IFiltroUsuario): Promise<IRespuestaApiLista<IUsuario>> {
        const { data } = await api.post(
            `/api/Usuarios/Listar`, filtro, {
            headers: {
                "Content-Type": "application/json",

            },
        });


        return data;
    }

}

export default ModeloUsuario;